module.exports = __webpack_public_path__ + "images/about@1x.png?f22dfbe0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about@1x.png
// module id = 591
// module chunks = 7